import React from 'react';
import Media from '../media';
import { IMG_BASE_PATH } from 'utils/constants';

const FormationPlayerCard = ({ thumbnail, plyrName, fallback }) => {
  return (
    <>
      <div className='si-playerCard'>
        {(thumbnail || thumbnail === 0) && (
          <div className='si-playerCard__thumb'>
            <Media
              imgSrc={`${IMG_BASE_PATH}images/players/${thumbnail}.png`}
              //imgAlt={plyrName}
              fallback={fallback}
            />
          </div>
        )}
        {plyrName && (
          <div className='si-playerCard__info'>
            <div className='si-playerCard__name'>{plyrName}</div>
          </div>
        )}
      </div>
    </>
  );
};

export default FormationPlayerCard;
